
(()=> {
 const cfgEl=document.getElementById('DoreLayoutConfig');
 let cfg={};try{cfg=JSON.parse(cfgEl?.textContent||'{}')}catch(e){cfg={}}
 const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];
 const localeRoot=(()=>{const r=String(cfg.rootUrl||'/');return r.endsWith('/')?r:r+'/';})();
 const esc=s=>String(s??'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));
 const drawer=$('[data-ds-drawer]'), backdrop=$('[data-ds-backdrop]'), cartDrawer=$('[data-ds-cart-drawer]');
 const openDrawer=()=>{drawer?.classList.add('is-open');backdrop?.classList.add('is-open');drawer?.setAttribute('aria-hidden','false');document.documentElement.style.overflow='hidden'};
 const closeDrawer=()=>{drawer?.classList.remove('is-open');drawer?.setAttribute('aria-hidden','true');if(!cartDrawer?.classList.contains('is-open')){backdrop?.classList.remove('is-open');document.documentElement.style.overflow=''}};
 const menuButton=$('[data-ds-menu]');

 const openMenuOnce=e=>{e?.preventDefault?.();if(drawer?.classList.contains('is-open'))return;openDrawer()};
 menuButton?.addEventListener('pointerup',openMenuOnce);
 menuButton?.addEventListener('click',e=>{if(e.detail===0)openMenuOnce(e)});
 $('[data-ds-close]')?.addEventListener('click',closeDrawer);
 $$('.ds-drawer a').forEach(a=>a.addEventListener('click',closeDrawer));
 document.querySelectorAll('.ds-lang-form,.ds-mobile-lang-form').forEach(form=>{
   const buttons=[...form.querySelectorAll('button[name="locale_code"]')];
   buttons.forEach(b=>{
     b.addEventListener('click',e=>{
       e.preventDefault();
       if(b.classList.contains('is-active')||form.dataset.doreSubmitting==='1')return;
       form.dataset.doreSubmitting='1';
       document.querySelectorAll('.ds-lang-form button,.ds-mobile-lang-form button').forEach(x=>x.classList.toggle('is-active',x.value===b.value));
       let localeInput=form.querySelector('input[data-dore-locale]');
       if(!localeInput){
         localeInput=document.createElement('input');
         localeInput.type='hidden';
         localeInput.name='locale_code';
         localeInput.dataset.doreLocale='1';
         form.appendChild(localeInput);
       }
       localeInput.value=b.value;
       document.documentElement.classList.add('ds-lang-switching');
       form.submit();
     });
   });
 });
 const search=$('[data-ds-search-panel]'), input=$('[data-ds-search-input]'), results=$('[data-ds-search-results]');
 $('[data-ds-search]')?.addEventListener('click',()=>{hideBundlePop?.();search?.classList.add('is-open');setTimeout(()=>input?.focus(),40)});
 $('[data-ds-search-close]')?.addEventListener('click',()=>search?.classList.remove('is-open'));
 let searchTimer;
 input?.addEventListener('input',()=>{clearTimeout(searchTimer);const q=input.value.trim();if(q.length<2){results.innerHTML='';return}searchTimer=setTimeout(async()=>{try{const r=await fetch(localeRoot+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6');const j=await r.json();const products=j?.resources?.results?.products||[];results.innerHTML=products.map(p=>'<a class="ds-search-card" href="'+esc(p.url)+'"><img src="'+esc(p.image||'')+'" alt=""><div><strong>'+esc(p.title)+'</strong><small>'+esc(p.price||'')+'</small></div></a>').join('')||'<div>'+cfg.searchEmpty+'</div>'}catch(e){}},180)});
 const cartBody=$('[data-ds-cart-body]'),cartTotal=$('[data-ds-cart-total]'),shipProgress=$('[data-ds-shipping-progress]'),shipCopy=$('[data-ds-shipping-copy]'),checkoutLink=$('[data-ds-checkout]'),cartHeadCount=$('[data-ds-cart-head-count]'),cartSaving=$('[data-ds-cart-saving]'),cartSavingValue=$('[data-ds-cart-saving-value]');
 const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'de-CH',{style:'currency',currency:'CHF'}).format((Number(cents)||0)/100);
 async function getCart(){const r=await fetch(localeRoot+'cart.js',{headers:{Accept:'application/json'}});return r.json()}
 async function renderCart(open=false){if(open){cartDrawer?.classList.add('is-open');cartDrawer?.setAttribute('aria-hidden','false');backdrop?.classList.add('is-open');document.documentElement.style.overflow='hidden';if(cartBody&&!cartBody.children.length)cartBody.innerHTML='<div class="ds-cart-loading"><span></span><span>'+cfg.cartLabel+'…</span></div>'}try{const c=await getCart();$$('[data-ds-cart-count]').forEach(el=>{el.textContent=c.item_count;el.classList.toggle('is-empty',!c.item_count)});if(cartHeadCount)cartHeadCount.textContent=c.item_count?'('+c.item_count+')':'';cartTotal.textContent=money(c.total_price);if(cartSaving&&cartSavingValue){const s=Number(c.total_discount)||0;cartSaving.style.display=s>0?'flex':'none';cartSavingValue.textContent=s>0?'− '+money(s):''}const threshold=9000,pct=Math.min(100,c.total_price/threshold*100);shipProgress.style.width=pct+'%';shipCopy.textContent=c.total_price>=threshold?cfg.shipDone:(cfg.shipPrefix+' '+money(threshold-c.total_price)+' '+cfg.shipUntil);checkoutLink.style.display=c.item_count?'grid':'none';cartBody.innerHTML=c.items.length?c.items.map((it,i)=>'<div class="ds-cart-item"><a href="'+esc(it.url||'#')+'"><img src="'+esc(it.image||'')+'" alt="'+esc(it.product_title)+'"></a><div class="ds-cart-item-copy"><a href="'+esc(it.url||'#')+'"><strong>'+esc(it.product_title)+'</strong></a><small>'+esc(it.variant_title&&it.variant_title!=='Default Title'?it.variant_title:'50 ml')+'</small><div class="ds-qty"><button type="button" data-ds-qty data-line="'+(i+1)+'" data-q="'+Math.max(0,it.quantity-1)+'">−</button><span>'+it.quantity+'</span><button type="button" data-ds-qty data-line="'+(i+1)+'" data-q="'+(it.quantity+1)+'">+</button></div></div><div class="ds-cart-price">'+((it.original_line_price||0)>(it.final_line_price||0)?'<s>'+money(it.original_line_price)+'</s>':'')+money(it.final_line_price)+'</div></div>').join(''):'<p>'+cfg.cartEmpty+'<a class="ds-empty-cart-cta" href="'+esc(cfg.allScentsUrl)+'">'+cfg.navAll+' →</a></p>';$$('[data-ds-qty]',cartBody).forEach(b=>b.addEventListener('click',async()=>{await fetch(localeRoot+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(b.dataset.line),quantity:Number(b.dataset.q)})});renderCart()}));}catch(e){if(cartBody)cartBody.innerHTML='<p>'+cfg.cartEmpty+'</p>'}}
 function closeCart(){cartDrawer?.classList.remove('is-open');cartDrawer?.setAttribute('aria-hidden','true');if(!drawer?.classList.contains('is-open')){backdrop?.classList.remove('is-open');document.documentElement.style.overflow=''}}
 const cartOpen=$('[data-ds-cart-open]');

 const openCartOnce=e=>{e?.preventDefault?.();if(cartDrawer?.classList.contains('is-open'))return;renderCart(true)};
 cartOpen?.addEventListener('pointerup',openCartOnce);
 cartOpen?.addEventListener('click',e=>{if(e.detail===0)openCartOnce(e)});
 $('[data-ds-cart-close]')?.addEventListener('click',closeCart);backdrop?.addEventListener('click',()=>{closeDrawer();closeCart()});
 async function applyDiscountBox(box){
   const input=box.querySelector('[data-ds-discount-input]');
   const status=box.querySelector('[data-ds-discount-status]');
   const button=box.querySelector('[data-ds-discount-apply]')||box.querySelector('button[type="submit"]');
   const code=String(input?.value||'').trim();
   if(!code)return;
   if(button)button.disabled=true;
   if(status){status.textContent='';status.classList.remove('is-error','is-success')}
   try{
     const r=await fetch(localeRoot+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:code})});
     const cart=await r.json();
     const found=(cart.discount_codes||[]).find(d=>String(d.code||'').toLowerCase()===code.toLowerCase());
     const ok=r.ok && (!found || found.applicable!==false);
     if(!ok)throw new Error('discount');
     if(status){status.textContent=cfg.discountSuccess||'Rabattcode angewendet';status.classList.add('is-success')}
     if(cartDrawer?.classList.contains('is-open')) await renderCart(false);
     else setTimeout(()=>window.location.reload(),450);
   }catch(err){
     if(status){status.textContent=cfg.discountInvalid||'Rabattcode ungültig';status.classList.add('is-error')}
   }finally{if(button)button.disabled=false}
 }
 $$('[data-ds-discount-form]').forEach(box=>{
   if(box.tagName==='FORM')box.addEventListener('submit',e=>{e.preventDefault();applyDiscountBox(box)});
   box.querySelector('[data-ds-discount-apply]')?.addEventListener('click',e=>{e.preventDefault();applyDiscountBox(box)});
 });
 document.addEventListener('click',async e=>{const b=e.target.closest('[data-dore-add]');if(!b)return;e.preventDefault();const id=Number(b.dataset.variant);if(!id)return;b.disabled=true;try{await fetch(localeRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});toast(cfg.addedToCart);await renderCart(true)}catch(err){toast(cfg.addFailed)}finally{b.disabled=false}});
 function toast(t){const el=$('[data-ds-toast]');if(!el)return;el.textContent=t;el.classList.add('is-show');setTimeout(()=>el.classList.remove('is-show'),1700)}
 window.DoreCart={render:renderCart,toast};
})();

;(()=>{
  const root=document.querySelector('[data-ds-advisor-lazy]');
  if(!root)return;
  const btn=root.querySelector('[data-ds-advisor-open]');
  const tpl=root.querySelector('[data-ds-advisor-template]');
  let loading=null;
  const loadCss=url=>new Promise(resolve=>{
    if(!url)return resolve();
    const found=[...document.querySelectorAll('link[rel="stylesheet"]')].some(l=>l.href===url);
    if(found)return resolve();
    const link=document.createElement('link');link.rel='stylesheet';link.href=url;
    link.onload=()=>resolve();link.onerror=()=>resolve();document.head.appendChild(link);
  });
  const loadJs=url=>new Promise((resolve,reject)=>{
    if(!url)return resolve();
    const old=document.querySelector('script[data-dore-advisor-runtime]');
    if(old){if(old.dataset.loaded==='1')return resolve();old.addEventListener('load',resolve,{once:true});return;}
    const s=document.createElement('script');s.src=url;s.defer=true;s.dataset.doreAdvisorRuntime='1';
    s.onload=()=>{s.dataset.loaded='1';resolve()};s.onerror=reject;document.head.appendChild(s);
  });
  const load=()=>{
    if(root.dataset.advisorReady==='1')return Promise.resolve();
    if(loading)return loading;
    if(tpl){root.appendChild(tpl.content.cloneNode(true));tpl.remove();}
    root.classList.add('is-loading');
    loading=Promise.all([loadCss(root.dataset.advisorCss),loadJs(root.dataset.advisorJs)]).then(()=>{
      root.dataset.advisorReady='1';root.classList.remove('is-loading');
    }).catch(()=>{root.classList.remove('is-loading')});
    return loading;
  };
  const openAfterLoad=()=>load().then(()=>{if(root.dataset.advisorReady==='1')btn?.click()});
  btn?.addEventListener('click',e=>{
    if(root.dataset.advisorReady==='1')return;
    e.preventDefault();e.stopImmediatePropagation();openAfterLoad();
  });
  document.addEventListener('click',e=>{
    const a=e.target.closest('a[href*="#duft-finder"]');
    if(!a||root.dataset.advisorReady==='1')return;
    e.preventDefault();openAfterLoad();
  });
  window.addEventListener('hashchange',()=>{if(location.hash==='#duft-finder'&&root.dataset.advisorReady!=='1')openAfterLoad()});
  if(location.hash==='#duft-finder')openAfterLoad();
})();

;(()=>{
  const root=document.querySelector('[data-ds-cookie]');
  if(!root||!window.Shopify?.loadFeatures)return;
  const banner=root.querySelector('[data-ds-cookie-banner]');
  const prefs=root.querySelector('[data-ds-cookie-prefs]');
  const analytics=root.querySelector('[data-ds-cookie-analytics]');
  const marketing=root.querySelector('[data-ds-cookie-marketing]');
  const open=()=>{root.hidden=false;banner.hidden=false;prefs.hidden=true;document.documentElement.classList.add('ds-cookie-open')};
  const close=()=>{root.hidden=true;document.documentElement.classList.remove('ds-cookie-open')};
  const current=cp=>{
    try{
      if(analytics)analytics.checked=!!cp.analyticsProcessingAllowed();
      if(marketing)marketing.checked=!!cp.marketingAllowed();
    }catch(e){}
  };
  const save=(all)=>{
    const cp=window.Shopify.customerPrivacy;
    if(!cp?.setTrackingConsent)return;
    const yes=all===true;
    const no=all===false;
    const payload={
      analytics:yes?true:no?false:!!analytics?.checked,
      marketing:yes?true:no?false:!!marketing?.checked,
      preferences:yes?true:no?false:true,
      saleOfData:false
    };
    cp.setTrackingConsent(payload,()=>close());
  };
  root.querySelector('[data-ds-cookie-accept]')?.addEventListener('click',()=>save(true));
  root.querySelector('[data-ds-cookie-reject]')?.addEventListener('click',()=>save(false));
  root.querySelector('[data-ds-cookie-settings]')?.addEventListener('click',()=>{banner.hidden=true;prefs.hidden=false});
  root.querySelector('[data-ds-cookie-back]')?.addEventListener('click',()=>{prefs.hidden=true;banner.hidden=false});
  root.querySelector('[data-ds-cookie-save]')?.addEventListener('click',()=>save(null));
  document.querySelectorAll('[data-ds-cookie-reopen]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();open();try{current(window.Shopify.customerPrivacy)}catch(_){}}));
  window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{
    if(error)return;
    const cp=window.Shopify.customerPrivacy;
    if(!cp)return;
    current(cp);
    let show=false;
    try{show=typeof cp.shouldShowBanner==='function'?cp.shouldShowBanner():false}catch(e){}
    if(new URLSearchParams(location.search).get('cookiepreview')==='1')show=true;
    if(show)open(); else close();
  });
  window.DoreCookieConsent={open};
})();
